import {
    Col,
    Row,
    Modal,
    Form,
    Input,
    Select,
    Switch,
    TimePicker,
    Dropdown,
    Table,
    Spin,
    Collapse,
    Button,
} from "antd";
import { React, useEffect, useState } from "react";
import ButtonComp from "../../ButtonComp/ButtonComp";
import CustomTable from "../../Table/CustomTable";
import BasicFormItem from "../../BasicFormItem/BasicFormItem";
import Loader from "../../../Components/Helpers/Loader";
import "./SyncMachine.css";
import { CheckCircleFilled, edit, trash, CloseCircleFilled } from "../../../Utils/imports";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CheckCircleOutlined } from "@ant-design/icons";

import { antIcon, formatCapabilities} from "../../../Helpers/helpers";
const SyncMachine = () => {
      let { current } = useSelector(state => state?.plant);
      let machinearr = [current?.machine?.machineName]

    return(
        
            <div className="boxBorder boxBorderRad p10">
        <div className="dflex alignCenter justifySB">
          <h4>SYNC MACHINES</h4>
        </div>
        <div className="bordernone dflex flexColumn gap5">
      <Button className="width100P synMachine">
        Select Machine
      </Button>
    <Form.Item name="machine name">
          <Select placeholder="" mode="multiple">
            {machinearr.map(machine => (
              <Select.Option key={machine} value={machine}>
                {formatCapabilities(machine)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        </div>
        <Form.Item className="width100P dflex alignCenter justifyFE">
          <ButtonComp
            htmlType="submit"
            theme="white"
            icon={<CheckCircleOutlined />}
            text="Sync & Save"
            />
        </Form.Item>
      </div>
        
    )
  }

  export default SyncMachine;
